module.exports = __webpack_public_path__ + "img/f2.048100d3.png";